import Tab from '@react/shared/components/Tab';
import Tabs from '@react/shared/components/Tabs';
import { MouseEvent, useState } from 'react';
import ExploreByCommunitySection from 'sly/hubPage/components/HubDynamicContent/ExploreByEntity/ExploreByCommunitySection';
import Heading from 'sly/system/Heading';

import { Entity } from './ExploreByCommunity.types';

export interface TabListItem {
  id?: number;
  slugs: string;
  title: string;
}

export interface TabList {
  id?: number;
  title: string;
  tabList: TabListItem[];
}

export interface ExploreByCommunitiesProps extends TabList {
  entity: Entity;
  serverRender?: boolean;
}

export default function ExploreByCommunity({
  title,
  tabList,
  entity,
  serverRender = true,
}: ExploreByCommunitiesProps) {
  const tabs = tabList?.map((tab) => tab.title);

  const [activeTab, setActiveTab] = useState<string>(tabs?.[0]);

  if (!tabs?.length) {
    return null;
  }

  const onClick = (e: MouseEvent<HTMLSpanElement>) => {
    setActiveTab((e.target as Element).id);
  };

  return (
    <section className='px-8 pt-12 md:pt-20'>
      <div className='mx-auto max-w-5xl'>
        <Heading
          font='font-t-l'
          className='mb-4 w-full'
          data-tp-id='gen-Heading-762446cc-b149-4f1c-8f6f-c626ef89d7d3'
        >
          {title}
        </Heading>
        <div className='w-full'>
          <Tabs activeTab={activeTab} className='px-0'>
            {tabs.map((tab) => {
              return (
                <Tab
                  key={tab}
                  id={tab}
                  onClick={onClick}
                  className='border-black normal-case text-slate-base hover:cursor-pointer'
                >
                  {tab?.toLowerCase()?.charAt(0).toUpperCase() +
                    tab?.toLowerCase()?.slice(1)}
                </Tab>
              );
            })}
          </Tabs>
        </div>
        <div>
          {tabList.map((tab) => (
            <ExploreByCommunitySection
              entity={entity}
              key={tab.title}
              active={activeTab === tab.title}
              tab={tab}
              serverRender={serverRender}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
